import { Button, Typography, useMediaQuery, CircularProgress } from '@mui/material'
import { useTheme } from '@mui/material/styles';
import React from 'react'

const Btn = ({ type, bg = "primary", variant = "contained", startIcon, loading, disabled, endIcon, width = 'fit-content', color, widthMob = 'fit-content', br, onClick, sx, children }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Button
            onClick={onClick}
            variant={variant}
            color={bg}
            startIcon={!loading && startIcon}
            endIcon={!loading && endIcon}
            disabled={disabled || loading}
            type={type}
            sx={{
                padding: { md: '10px 50px', xs: 2 },
                fontWeight: 'bold', fontSize: '16px',
                borderRadius: '8px',
                ...(color && { color }),
                width: { md: width, xs: widthMob },
                border: br && `2px solid ${color ? color : theme.palette.secondary.main}`,
                height: '45px', '.MuiButton-endIcon': { mr: 1 },
                ...sx
            }}>
            {loading ? (
                <CircularProgress size={24} color="inherit" />
            ) : (
                <Typography variant={isMobile ? 'body1' : 'h6'} fontWeight={600} color={'inherit'} >
                    {children}
                </Typography>
            )}
        </Button>
    )
}

export default Btn